import React, { Component } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Schedule from "@material-ui/icons/Schedule";
import List from "@material-ui/icons/List";

import NavPills from "components/NavPills/NavPills.jsx";
import pillsStyle from "assets/jss/material-kit-react/components/pillsStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Sub01 from "views/DocPage/DocPage01_sub01.jsx";
import Sub02 from "views/DocPage/DocPage01_sub02.jsx";
import Sub03 from "views/DocPage/DocPage01_sub03.jsx";

class DocPage01 extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = { Edocument: [], page1: true, page2: true, page3: true };
  }
  componentDidMount() {
    this.setState({ Edocument: this.props.edocument });
  }
  handleInitEdocument = async () => {
    if (await this.props.initDocument()) {
      this.setState({ Edocument: this.props.edocument });
    }
  };
  initDocument = async page => {
    let nextState = {};
    nextState[page] = false;
    this.setState(nextState);
    await this.props.initDocument();
    nextState[page] = true;
    this.setState(nextState);
  };
  render() {
    return (
      <NavPills
        color="primary"
        tabs={[
          {
            tabButton: "내 결재함",
            tabIcon: Dashboard,
            tabContent: this.state.page1 ? (
              <Sub01
                edocument={this.props.edocument}
                initDocument={this.initDocument}
              />
            ) : null
          },
          {
            tabButton: "결재 대기",
            tabIcon: Schedule,
            tabContent: this.state.page2 ? (
              <Sub02
                edocument={this.props.edocument}
                initDocument={this.initDocument}
              />
            ) : null
          },
          {
            tabButton: "결재 완료",
            tabIcon: List,
            tabContent: this.state.page3 ? (
              <Sub03
                edocument={this.props.edocument}
                initDocument={this.initDocument}
              />
            ) : null
          }
        ]}
      />
    );
  }
}

export default withStyles(pillsStyle)(DocPage01);
